import { useQuery, UseQueryResult } from 'react-query'
import User from '../models/user'
import { getDeveloperApiUrl } from '../utils/env'
import { FetchError } from '../utils/error'
import { GET_OPTIONS } from '../utils/fetch'
import UserDto from '../dto/userDto'
import { useAuth } from 'context/authContext'

function userFromDto(dto: UserDto): User {
  return dto
}

async function getUser(): Promise<User | undefined> {
  const url = `${getDeveloperApiUrl()}/global/userandaccount/getuserinfo`
  const response = await fetch(url, {
    ...GET_OPTIONS
  })

  if (!response.ok) {
    throw new FetchError(response)
  }

  const dto = (await response.json()) as UserDto

  return userFromDto(dto)
}

export const userQueryKey = 'user'

export default function useUser(): UseQueryResult<User> {
  const { token } = useAuth()
  return useQuery({
    queryFn: getUser,
    queryKey: userQueryKey,
    staleTime: Infinity,
    enabled: !!token // Only query if we are logged in
  })
}
